/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';

export default function ProductPriceExact({ pricing, ...rest }) {
  // Some products won't have a price and won't contain a £ symbol.
  // Show RRP only for those with an actual price.
  const isRrp = pricing.price?.includes('£');
  return isRrp ? (
    <span {...rest}>RRP: {pricing.price}</span>
  ) : (
    <span {...rest}>{pricing.price}</span>
  );
}
